/**
 * Design tokens – single source of truth for colors, spacing, radius.
 * Do NOT hardcode these in createTheme or component overrides.
 * Use for: brand switching, white-label, dark mode, future scaling.
 */
export const tokens = {
  colors: {
    // Brand / primary
    primary: "#390095",
    primaryDark: "#6630d2",
    primaryLight: "rgba(57, 0, 149, 0.059)",
    // Secondary / neutral
    secondary: "#2a3140",
    text: "#181e2a",
    textMuted: "#585e6d",
    border: "#dfe1e6",
    background: "#ffffff",
    backgroundAlt: "#f8f9fb",
    // Semantic
    danger: "#e82c35",
    success: "#1b963a",
    successLight: "rgba(27, 150, 58, 0.078)",
    warning: "#ca8a04",
    info: "#1d48e6",
    // Grays (for soft variants, disabled, etc.)
    gray50: "#f8f9fb",
    gray100: "#f3f4f6",
    gray200: "#dfe1e6",
    gray500: "#585e6d",
    gray800: "#181e2a",
    gray900: "#0e121d",
  },
  spacing: {
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 24,
    xxl: 32,
  },
  radius: {
    sm: 4,
    md: 8,
    lg: 12,
  },
  typography: {
    fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontSize: {
      xs: 11,
      sm: 12,
      md: 13,
      base: 14,
      lg: 16,
      xl: 20,
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
  },
};

/** Dark mode token overrides (only values that change). */
export const tokensDark = {
  colors: {
    primary: "#6630d2",
    primaryLight: "rgba(102, 48, 210, 0.15)",
    text: "#f8f9fb",
    textMuted: "#b0b4bc",
    border: "#3a3f4a",
    background: "#0e121d",
    backgroundAlt: "#1a1f2e",
    gray50: "#1a1f2e",
    gray100: "#2a3140",
    gray200: "#3a3f4a",
    gray500: "#b0b4bc",
    gray800: "#e8eaed",
    gray900: "#f8f9fb",
  },
};
